import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Container, Counter, Label, Age, Price, IconPlus, IconMinus, Count } from './ticketCounter.styles';
import messages from './ticketCounter.messages';
import { renderWhenNotNil, renderWhenTrue } from '../../../../../../shared/utils/rendering';

export class TicketCounter extends PureComponent {
  static propTypes = {
    ageLimit: PropTypes.array,
    className: PropTypes.string,
    count: PropTypes.number,
    price: PropTypes.string,
    type: PropTypes.string,
    areTicketsFull: PropTypes.bool,
    isGroupPrice: PropTypes.bool,
    onCountChanged: PropTypes.func.isRequired,
  };

  static defaultProps = {
    count: 0,
  };

  handleIncreaseCount = () => this.props.onCountChanged(this.props.count + 1);
  handleDecreaseCount = () => this.props.onCountChanged(this.props.count - 1);

  renderAgeLimit(ageLimit) {
    const isSingle = ageLimit.length === 1;

    return <Age>{isSingle ? `${ageLimit}+` : `${ageLimit[0]}-${ageLimit[1]}`}</Age>;
  }

  renderPrice = () => {
    const { isGroupPrice, price } = this.props;
    return isGroupPrice ? '' : <FormattedMessage {...messages.price} values={{ price }} />;
  };

  render() {
    const { type, className, count, ageLimit, areTicketsFull } = this.props;

    return (
      <Container className={className}>
        <Label>
          <Price>
            <FormattedMessage {...messages[type]} /> {this.renderPrice()}
          </Price>
          {renderWhenNotNil(this.renderAgeLimit)(ageLimit)}
        </Label>
        <Counter>
          {renderWhenTrue(() => <IconMinus onClick={this.handleDecreaseCount} />)(count > 0)}
          <Count>{count}</Count>
          <IconPlus onClick={this.handleIncreaseCount} disabled={areTicketsFull} />
        </Counter>
      </Container>
    );
  }
}
